import React from 'react';
import { Stack } from '@mui/material';
import { BannerDescription } from 'new/elements/BannerDescription';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_AI_TOOL_SETS } from 'new/constants/pathnames';
import { ToolsetsTab } from './ToolsetsTab';
import styles from './ToolsAndToolsetsSection.module.scss';

export const ToolsetsSection: ScreenComponent<Record<string, never>> = () => {
  return (
    <Stack className={styles.container}>
      <BannerDescription
        title="Toolsets & MCP"
        description="Create and manage AI toolsets from your tools. Each toolset bundles tools with an MCP server for deployment."
      />
      <div className={styles.tabContent}>
        <ToolsetsTab />
      </div>
    </Stack>
  );
};

ToolsetsSection.displayName = 'ToolsetsSection';

ToolsetsSection.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_AI_TOOL_SETS}`,
  domain: 'ai',
  header: {
    title: 'Toolsets & MCP',
    slugTitle: 'Toolsets & MCP',
  },
  screenName: 'Toolsets',
};
